(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["marcas-logos"] && !Shopify.designMode) return;
  try {
    (() => {
    const iniciar = (raiz) => {
      if (raiz.dataset.listo) return;
      raiz.dataset.listo = '1';
      const pista = raiz.querySelector('[data-marcas-pista]');
      const prev = raiz.querySelector('[data-marcas-prev]');
      const next = raiz.querySelector('[data-marcas-next]');
      if (!pista || !prev || !next) return;
      const reducir = window.matchMedia('(prefers-reduced-motion: reduce)');

      // Los logos se piden la primera vez que se abre el menú, no en cada visita.
      let cargados = false;
      const cargar = () => {
        if (cargados) return;
        cargados = true;
        pista.querySelectorAll('img[data-src]').forEach((img) => {
          img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      };

      const actualizar = () => {
        const max = pista.scrollWidth - pista.clientWidth - 2;
        prev.hidden = pista.scrollLeft <= 2;
        next.hidden = max <= 0 || pista.scrollLeft >= max;
      };
      const mover = (sentido) => {
        pista.scrollBy({ left: sentido * pista.clientWidth, behavior: reducir.matches ? 'auto' : 'smooth' });
      };

      prev.addEventListener('click', () => mover(-1));
      next.addEventListener('click', () => mover(1));
      pista.addEventListener('scroll', actualizar, { passive: true });
      window.addEventListener('resize', actualizar);

      const item = raiz.closest('.cab-bl__nav-item') || raiz;
      const abrir = () => { cargar(); actualizar(); };
      item.addEventListener('mouseenter', abrir);
      item.addEventListener('focusin', abrir);
      actualizar();
    };

    const arrancar = () => document.querySelectorAll('.marcas--mega[data-marcas]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
    document.addEventListener('shopify:section:load', arrancar);
  })();
  } catch(e) { console.error(e); }
})();

})();
